import { render } from "./tasks-page.vue?vue&type=template&id=ff6751c4"
import script from "./tasks-page.vue?vue&type=script&lang=js"
export * from "./tasks-page.vue?vue&type=script&lang=js"

import "./tasks-page.vue?vue&type=style&index=0&id=ff6751c4&lang=scss"

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__